import type { CardDirection, FlowThemeCardMotion } from '../../cardMotion';

/** The card pulls in from the side like a carriage and eases to a stop. */
export const railwayCardMotion = (isMobile: boolean): FlowThemeCardMotion => {
  const travel = isMobile ? '60%' : '42%';
  return {
    variants: {
      enter: (direction: CardDirection) => ({ opacity: 0, x: direction > 0 ? travel : `-${travel}` }),
      center: { opacity: 1, x: 0 },
      exit: (direction: CardDirection) => ({ opacity: 0, x: direction > 0 ? `-${travel}` : travel }),
    },
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
  };
};
